import React from 'react';
import Icon from '../../../components/AppIcon';

const WelcomeScreen = ({ onQuickStart }) => {
  const quickStartOptions = [
    {
      icon: 'Sparkles',
      title: 'Découvrir mes options',
      description: 'Explorez les filières adaptées à votre profil',
      question: 'Quelles sont les filières qui correspondent à mon profil ?'
    },
    {
      icon: 'GraduationCap',
      title: 'Carrières possibles',
      description: 'Découvrez les métiers selon vos intérêts',
      question: 'Quels métiers puis-je exercer avec mes compétences ?'
    },
    {
      icon: 'School',
      title: 'Écoles recommandées',
      description: 'Trouvez les meilleures écoles pour vous',
      question: 'Quelles écoles correspondent à mes objectifs ?'
    },
    {
      icon: 'TrendingUp',
      title: 'Débouchés professionnels',
      description: 'Informations sur les opportunités d\'emploi',
      question: 'Quels sont les débouchés dans le domaine scientifique ?'
    }
  ];

  return (
    <div className="flex-1 flex items-center justify-center p-4 md:p-6 lg:p-8">
      <div className="max-w-4xl w-full">
        <div className="text-center mb-8 md:mb-12">
          <div className="w-16 h-16 md:w-20 md:h-20 rounded-2xl bg-gradient-to-br from-primary to-secondary flex items-center justify-center mx-auto mb-4 md:mb-6">
            <Icon name="MessageSquare" size={32} color="#FFFFFF" />
          </div>
          <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-3 md:mb-4">
            Assistant d'Orientation IA
          </h1>
          <p className="text-sm md:text-base lg:text-lg text-muted-foreground max-w-2xl mx-auto">
            Posez vos questions sur l'orientation scolaire et recevez des recommandations personnalisées basées sur votre profil et vos aspirations.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4 lg:gap-6">
          {quickStartOptions?.map((option, index) => (
            <button
              key={index}
              onClick={() => onQuickStart(option?.question)}
              className="group p-4 md:p-6 rounded-2xl bg-card border border-border hover:border-primary transition-all text-left hover:shadow-lg"
            >
              <div className="flex items-start gap-3 md:gap-4">
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0 group-hover:bg-primary group-hover:scale-110 transition-all">
                  <Icon 
                    name={option?.icon} 
                    size={20} 
                    color="var(--color-primary)" 
                    className="group-hover:text-primary-foreground"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="font-semibold text-sm md:text-base lg:text-lg text-foreground mb-1 md:mb-2 group-hover:text-primary transition-colors">
                    {option?.title}
                  </h3>
                  <p className="text-xs md:text-sm text-muted-foreground line-clamp-2">
                    {option?.description}
                  </p>
                </div>
                <Icon 
                  name="ArrowRight" 
                  size={20} 
                  className="text-muted-foreground group-hover:text-primary group-hover:translate-x-1 transition-all flex-shrink-0"
                />
              </div>
            </button>
          ))}
        </div>

        <div className="mt-8 md:mt-12 p-4 md:p-6 rounded-2xl bg-muted border border-border">
          <div className="flex items-start gap-3 md:gap-4">
            <div className="w-8 h-8 md:w-10 md:h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
              <Icon name="Info" size={20} color="var(--color-primary)" />
            </div>
            <div className="flex-1">
              <h4 className="font-semibold text-sm md:text-base text-foreground mb-2">
                Comment ça marche ?
              </h4>
              <ul className="space-y-2 text-xs md:text-sm text-muted-foreground">
                <li className="flex items-start gap-2">
                  <Icon name="Check" size={16} className="text-success flex-shrink-0 mt-0.5" />
                  <span>Posez vos questions sur l'orientation et les filières</span>
                </li>
                <li className="flex items-start gap-2">
                  <Icon name="Check" size={16} className="text-success flex-shrink-0 mt-0.5" />
                  <span>Recevez des recommandations basées sur votre profil</span>
                </li>
                <li className="flex items-start gap-2">
                  <Icon name="Check" size={16} className="text-success flex-shrink-0 mt-0.5" />
                  <span>Explorez les filières et écoles suggérées</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeScreen;